import React, { Fragment } from 'react';
import { List, ListItem, ListItemText, ListItemIcon, Divider, } from '@material-ui/core';
import CallToAction from '@material-ui/icons/Call';
import Mail from '@material-ui/icons/Mail';



export const ContactDetail = (props) => {

  const { phone, extension, mail } = props;

  return (
    <Fragment>
        {phone ?
        <List>
          <ListItem
            button
            href={`tel:${phone}`}
            onClick={() => props.handleCall(phone)}
          >
            <ListItemIcon><CallToAction /></ListItemIcon>
            <ListItemText>
              {phone} {extension ? `\u00A0 ext: ${extension}` : null}
            </ListItemText>
          </ListItem>
        </List>
          : null
        }
        {phone && mail? <Divider/> : null}
        {mail ?
        <List>
          <ListItem
            button
            href={`mailto:${mail}`}
            onClick={() => props.handleMail(mail)}
          >
            <ListItemIcon><Mail/></ListItemIcon>
            <ListItemText>
              {mail}
            </ListItemText>
          </ListItem>
        </List>
          : null
          }
    </Fragment>
  )
}


// WEBPACK FOOTER //
// ./src/components/ContactDetail.js